import { useMemo } from 'react';
import { withStyles } from '@material-ui/core';
import ExceptionNumberDisplay from '../common/ExceptionNumberDisplay';

const styles = (theme) => ({
  label: {
    color: theme.TextColor,
    fontSize: theme.headerTextFontSize
  },
  value: {
    color: theme.TextColor,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600
  },
  valueContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 8
  }
});

const DeliveryReceiptDetailsADE = ({ classes, exceptionDetails, getExceptionDescription, DispatchStore, configJSON }) => {
  const { code, adeNumber } = exceptionDetails || {};
  const description = useMemo(() => getExceptionDescription(code), [code]);
  return (
    <>
      <div className={classes.valueContainer}>
        <span className={classes.label}>Exception Type</span>
        <span className={classes.value}>{description}</span>
      </div>
      <ExceptionNumberDisplay 
        adeNumber={adeNumber} 
        DispatchStore={DispatchStore} 
        configJSON={configJSON} 
      />
    </>
  );
};

export default withStyles(styles)(DeliveryReceiptDetailsADE);
